import React from 'react';
import {useInView, type IntersectionOptions} from 'react-intersection-observer';
import {useTransition, useLocation, useFetcher, Await} from '@remix-run/react';
import clsx from 'clsx';

//components
import {LoadingSpinner} from 'components/global/LoadingSpinner';
import BlogCard from './BlogCard';
import type {SanityDocBlog} from '~/domains/blog';

export default function BlogListingFetch({totalBlogs}: {totalBlogs: number}) {
  const {ref, inView} = useInView();
  const location = useLocation();
  const [range, setRange] = React.useState<{start: number; end: number}>({
    start: 9,
    end: 16,
  });
  const [blogs, setBlogs] = React.useState<SanityDocBlog[] | []>([]);

  const allBlogsFetched = range.end >= totalBlogs;
  const {load, data, state} = useFetcher();
  React.useEffect(() => {
    if (inView && !allBlogsFetched && state !== 'loading') {
      // fetchNextPage();
      load(`${location.pathname}?start=${range.start}&end=${range.end}`);
      setRange((prev) => ({start: prev.start + 9, end: prev.end + 9}));
      if (data?.blogs) {
        setBlogs((prev) => [...prev, ...data.blogs]);
      }
    }
  }, [inView, state]);

  return (
    <div className="md:py-10">
      <ul className="grid gap-y-8 gap-x-[72px] md:grid-cols-3 md:gap-y-24">
        <React.Suspense fallback="loading">
          <Await resolve={blogs}>
            {(blogs: SanityDocBlog[]) => {
              return (
                blogs &&
                blogs.map((b: SanityDocBlog) => (
                  <li key={`${b._id}-${b._rev}`} className="md:col-span-1">
                    <BlogCard {...b} type="vertical" />
                  </li>
                ))
              );
            }}
          </Await>
        </React.Suspense>
      </ul>
      <div
        className={clsx([
          totalBlogs > 7 ? 'py-10 md:mt-20' : 'hidden',
          allBlogsFetched && 'hidden',
          // isFetching && isFetchingNextPage ? 'opacity-100' : 'opacity-0',
        ])}
        ref={ref}
      >
        <div className="flex items-center justify-center">
          {state === 'loading' && (
            <div className="w-14">
              <LoadingSpinner className="text-hk-orange" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
